import styled from 'styled-components';

import { rem, mediaUp } from 'approot/shared/style';
import { spacing16 } from 'approot/shared/styles/spacing.style';
import { PrintHidden } from 'approot/shared/styles/print.style';

const fadeInDelay = '3s';
const heroMinHeight = rem(320 * 0.75);

type WrapperProps = {
  $isEditing?: boolean;
};

export const Wrapper = styled.div<WrapperProps>`
  position: relative;

  ${({ $isEditing }) =>
    $isEditing &&
    `
    z-index: 10;
  `};

  ${PrintHidden}
`;

type HeroProps = {
  $isPreview?: boolean;
  $isEditing?: boolean;
  $rounded?: boolean;
};

export const Hero = styled.div<HeroProps>`
  position: relative;
  display: block;
  text-align: center;
  padding: 0;
  margin: ${rem(1)} 0 ${rem(45)} 0;

  background-position: center center;
  background-size: cover;

  min-height: ${heroMinHeight};

  ${mediaUp.lg`
    margin: ${rem(1)} 0 ${rem(44)} 0;
  `};

  ${mediaUp.xl`
    margin: ${rem(1)} 0 ${rem(52)} 0;
  `};

  @media print {
    content: normal;
    margin-bottom: 0;
  }

  ${({ $isPreview }) =>
    $isPreview &&
    `
    &::after {
      border-left: none;
      border-right: none;
    }`};
  ${({ $isEditing }) =>
    $isEditing &&
    `
      pointer-events: none;
    `};

  ${({ $rounded }) =>
    $rounded &&
    `
      border-radius: 10px;
    `};
`;

type HeroForegroundBackgroundProps = {
  $isEditing?: boolean;
  $fadeInHero: boolean;
  $rounded?: boolean;
};

// eslint-disable-next-line
export const HeroForegroundBackground = styled.div<HeroForegroundBackgroundProps>`
  z-index: 0;
  display: block;
  position: absolute;
  width: 100%;
  top: 0;
  left: 0;
  background-size: cover;
  background-position: center center;
  height: 100%;
  min-height: ${heroMinHeight};

  ${mediaUp.md`
      margin: 0 0 ${rem(45)} 0;
    `};

  ${({ $isEditing }) =>
    !$isEditing &&
    `
      opacity: 0;
    `};

  ${({ $isEditing, $fadeInHero }) =>
    !$isEditing &&
    $fadeInHero &&
    `
      transition: opacity ${fadeInDelay};
      opacity: 1;
    `};

  ${({ $rounded }) =>
    $rounded &&
    `
      border-radius: 10px;
    `};
`;

type HeroForegroundProps = {
  $isEditing?: boolean;
  $isPreview?: boolean;
  $rounded?: boolean;
};

export const HeroForeground = styled.div<HeroForegroundProps>`
  position: relative;

  ${
    '' /* // needed to have dropdown menu above buttons when editing unit (see PR 1000) */
  }
  z-index: 6;

  ${({ $isPreview }) =>
    $isPreview &&
    `
      z-index: 5;
    `};
`;

export const HeroImage = styled.span`
  display: block;
  width: 1px;
  height: 1px;
  overflow: hidden;
`;

export const HeroEditButtons = styled.div`
  display: flex;
  button {
    margin-right: ${rem(spacing16)};
  }
`;
